import { useState, useEffect, useCallback } from 'react';

export const useStoredText = (contentUrl) => {
    const [content, setContent] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadContent = useCallback(async () => {
        if (!contentUrl) return;
        
        setIsLoading(true);
        setError(null);
        
        try {
            const response = await fetch(contentUrl);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const textContent = await response.text();
            setContent(textContent);
        } catch (err) {
            setError(err.message);
            console.error('Failed to load text content:', err);
        } finally {
            setIsLoading(false);
        }
    }, [contentUrl]);

    useEffect(() => {
        loadContent();
    }, [contentUrl, loadContent]);

    return { content, isLoading, error, refetch: loadContent };
}